{
  "identities.messages.1010001": "Don",
  "identities.messages.1010002": "Don ni {provider} ye",
  "identities.messages.1010003": "I ka kan k'a lajɛ ko i ye i ye.",
  "identities.messages.1010004": "I ka kan ka filanan fila labɛn.",
  "identities.messages.1010005": "Kɔrɔbɔ",
  "identities.messages.1010006": "Dantigɛli kode",
  "identities.messages.1010007": "Kope seginni kode",
  "identities.messages.1010008": "Taa fɛ ni materyɛli kilisi ye",
  "identities.messages.1010009": "Taa fɛ",
  "identities.messages.1010010": "Taa fɛ",
  "identities.messages.1010011": "Don ni materyɛli kilisi ye",
  "identities.messages.1010012": "I ka WebAuthn minɛn labɛn (i n'a fɔ lakana kilisi, jɔnsen kɛminɛn, ...) ka tugu taa fɛ kan.",
  "identities.messages.1010013": "Taa fɛ",
  "identities.messages.1010014": "Kode dɔ ye ci i ye min adirɛsi di. Ni i ma a sɔrɔ, i ka kan ka adirɛsi daɲɛgafe lajɛ ka segin k'a lajɛ.",
  "identities.messages.1010015": "Donkow kode ci",
  "identities.messages.1010016": "I ye a lajɛ ka don ni \"{duplicateIdentifier}\" ye, nka nin bataki in bɛ kɛ baara la ni jatebɔsɛbɛn wɛrɛ ye. I ka don i ka jatebɔsɛbɛn na ni sugandi dɔ ye ninnu duguma walasa k'i ka \"{duplicateIdentifier}\" jatebɔsɛbɛn fara a kan {provider} la i n'a fɔ donkow fɛɛrɛ wɛrɛ.",
  "identities.messages.1010017": "Don ani jɛɲɔgɔnya",
  "identities.messages.1010018": "Lajɛ ni {provider} ye",
  "identities.messages.1010019": "Kode ɲini walasa ka taa fɛ",
  "identities.messages.1010021": "Don ni daɲɛgafe kilisi ye",
  "identities.messages.1010022": "Don ni daɲɛgafe ye",
  "identities.messages.1010023": "Kode ci {address} ma",
  "identities.messages.1040001": "I tɔgɔ sɛbɛn",
  "identities.messages.1040002": "I tɔgɔ sɛbɛn ni {provider} ye",
  "identities.messages.1040003": "Taa fɛ",
  "identities.messages.1040004": "I tɔgɔ sɛbɛn ni lakana kilisi ye",
  "identities.messages.1040005": "Kode dɔ ye ci adirɛsi minnu na i ye minnu di. Ni i ma cikan sɔrɔ, adirɛsi daɲɛgafe lajɛ ka tɔgɔsɛbɛnni segin kɛ.",
  "identities.messages.1040006": "Tɔgɔsɛbɛnni kode ci",
  "identities.messages.1040007": "I tɔgɔ sɛbɛn ni daɲɛgafe kilisi ye",
  "identities.messages.1040008": "Segin",
  "identities.messages.1040009": "I ka kan ka jaminani dɔ sugandi walasa k'i yɛrɛ dantigɛ.",
  "identities.messages.1050001": "I ka yɛlɛmaw marayara!",
  "identities.messages.1050002": "Jɛɲɔgɔnya {provider}",
  "identities.messages.1050003": "Jɛɲɔgɔnya bɔ {provider} la",
  "identities.messages.1050004": "TOTP Dantigɛcogo Porogaramu jɛɲɔgɔnya bɔ",
  "identities.messages.1050005": "Dantigɛcogo porogaramu QR kode",
  "identities.messages.1050006": "{secret}",
  "identities.messages.1050007": "Kope seginni kodew yira",
  "identities.messages.1050008": "A bila baara la",
  "identities.messages.1050009": "{secret}",
  "identities.messages.1050010": "Ninnu ye i ka kope seginni kodew ye. I k'olu mara yɔrɔ lakananen dɔ la!",
  "identities.messages.1050011": "Kope seginni kodew lajɛ",
  "identities.messages.1050012": "Lakana kilisi fara a kan",
  "identities.messages.1050013": "Lakana kilisi tɔgɔ",
  "identities.messages.1050014": "U ye gundow kɛ {used_at, date, long} la",
  "identities.messages.1050015": "{secrets_list}",
  "identities.messages.1050016": "Nin fɛɛrɛ in dabila",
  "identities.messages.1050017": "Dantigɛcogo Gundo",
  "identities.messages.1050018": "Lakana kilisi \"{display_name}\" bɔ",
  "identities.messages.1050019": "Daɲɛgafe kilisi fara a kan",
  "identities.messages.1050020": "Daɲɛgafe kilisi \"{display_name}\" bɔ",
  "identities.messages.1060001": "I ye i ka jatebɔsɛbɛn segin sɔrɔ ka ɲɛ. I ka kan ka i ka daɲɛgafe yɛlɛma walima ka donkow fɛɛrɛ wɛrɛ labɛn (i n'a fɔ jama ka don) ni miniti {privileged_session_expires_at_unix_until_minutes} nataw kɔnɔ.",
  "identities.messages.1060002": "Bataki dɔ ye ci min na seginni jɛɲɔgɔnya bɛ, i bataki adirɛsi la i ye min di. Ni i ma bataki sɔrɔ, adirɛsi daɲɛgafe lajɛ ka a lajɛ ko i bɛ ka adirɛsi min kɛ i ka tɔgɔsɛbɛnni kɛra ni min ye a baara.",
  "identities.messages.1060003": "Bataki dɔ ye ci min na seginni kode bɛ, i bataki adirɛsi la i ye min di. Ni i ma bataki sɔrɔ, adirɛsi daɲɛgafe lajɛ ka a lajɛ ko i bɛ ka adirɛsi min kɛ i ka tɔgɔsɛbɛnni kɛra ni min ye a baara.",
  "identities.messages.1060004": "Seginni kode dɔ ye ci \"{masked_address}\" ma. Ni i ma a sɔrɔ, adirɛsi daɲɛgafe lajɛ ka a lajɛ ko i bɛ ka adirɛsi min kɛ i ka tɔgɔsɛbɛnni kɛra ni min ye a baara.",
  "identities.messages.1060005": "Segin ka i ka jatebɔsɛbɛn sɔrɔ ni i ka seginni adirɛsi bɛɛ di ye.",
  "identities.messages.1060006": "I b'a fɛ ka i ka jatebɔsɛbɛn segin sɔrɔ cogo di?",
  "identities.messages.1060007": "Segin",
  "identities.messages.1070001": "Daɲɛgafe",
  "identities.messages.1070002": "{title}",
  "identities.messages.1070003": "Mara",
  "identities.messages.1070004": "Jaatigiya",
  "identities.messages.1070005": "A bila",
  "identities.messages.1070006": "Kode kɔrɔbɔ",
  "identities.messages.1070007": "Bataki",
  "identities.messages.1070008": "Kode segin ci",
  "identities.messages.1070009": "Taa fɛ",
  "identities.messages.1070010": "Seginni kode",
  "identities.messages.1070011": "Kɔrɔbɔli kode",
  "identities.messages.1070012": "Tɔgɔsɛbɛnni kode",
  "identities.messages.1070013": "Donni kode",
  "identities.messages.1070014": "Don ani jaminani jɛɲɔgɔnya",
  "identities.messages.1070015": "I ka kan ka kaptja gɛlɛya labɛn walasa ka taa fɛ.",
  "identities.messages.1070016": "Seginni adirɛsi",
  "identities.messages.1070017": "Telefɔni nimɔrɔ",
  "identities.messages.1080001": "Bataki dɔ ye ci min na kɔrɔbɔli jɛɲɔgɔnya bɛ, i bataki adirɛsi la i ye min di. Ni i ma bataki sɔrɔ, adirɛsi daɲɛgafe lajɛ ka a lajɛ ko i bɛ ka adirɛsi min kɛ i ka tɔgɔsɛbɛnni kɛra ni min ye a baara.",
  "identities.messages.1080002": "I ye i ka bataki adirɛsi kɔrɔbɔ ka ɲɛ.",
  "identities.messages.1080003": "Bataki dɔ ye ci min na kɔrɔbɔli kode bɛ, i bataki adirɛsi la i ye min di. Ni i ma bataki sɔrɔ, adirɛsi daɲɛgafe lajɛ ka a lajɛ ko i bɛ ka adirɛsi min kɛ i ka tɔgɔsɛbɛnni kɛra ni min ye a baara.",
  "identities.messages.4000001": "{reason}",
  "identities.messages.4000002": "I ka kan ka {property} bila ka segin k'a lajɛ.",
  "identities.messages.4000003": "janya ka kan ka kɛ >= {min_length}, nka a ye {actual_length}",
  "identities.messages.4000004": "a tɛ bɛn \"{pattern}\" ma",
  "identities.messages.4000005": "Daɲɛgafe tɛ se ka kɛ baara la {reason} kosɔn.",
  "identities.messages.4000006": "Jaminanw i ye minnu di olu tɛ tiɲɛ, i ka daɲɛgafe walima baarakɛla tɔgɔ, bataki adirɛsi, walima telefɔni nimɔrɔ sɛbɛnni filiw lajɛ.",
  "identities.messages.4000007": "Jatebɔsɛbɛn bɛ yen kaban ni lasebenw kelen ye (bataki, telefɔni, baarakɛla tɔgɔ, ...).",
  "identities.messages.4000008": "Dantigɛli kode i ye min di a tɛ tiɲɛ, i ka segin k'a lajɛ.",
  "identities.messages.4000009": "Donkow lasebenw ma sɔrɔ. I ye a ɲagami k'olu sigi sen'wa? Nin b'a se ka bɔ baarakɛlaw ka labɛncogo fili la fana.",
  "identities.messages.4000010": "Jatebɔsɛbɛn tɛ baara la foyi. I ye i ka bataki adirɛsi kɔrɔbɔ ɲagami wa?",
  "identities.messages.4000011": "I ma TOTP minɛn labɛn.",
  "identities.messages.4000012": "U ye nin kope seginni kode in kɛ baara la kaban.",
  "identities.messages.4000013": "I ma WebAuthn minɛn labɛn.",
  "identities.messages.4000014": "I ma kope seginni kodew labɛn.",
  "identities.messages.4000015": "Nin jatebɔsɛbɛn tɛ yen walima lakana kilisi ma labɛn a la.",
  "identities.messages.4000016": "Kope seginni kode tɛ tiɲɛ.",
  "identities.messages.4000017": "janya ka kan ka kɛ <= {max_length}, nka a ye {actual_length}",
  "identities.messages.4000018": "a ka kan ka kɛ >= {minimum} nka u ye {actual} sɔrɔ",
  "identities.messages.4000019": "a ka kan ka kɛ > {minimum} nka u ye {actual} sɔrɔ",
  "identities.messages.4000020": "a ka kan ka kɛ <= {maximum} nka u ye {actual} sɔrɔ",
  "identities.messages.4000021": "a ka kan ka kɛ < {maximum} nka u ye {actual} sɔrɔ",
  "identities.messages.4000022": "{actual} tɛ {base} ka jateden ye",
  "identities.messages.4000023": "a ka ca {max_items} fɛnw kan, nka u ye {actual_items} fɛnw sɔrɔ",
  "identities.messages.4000024": "a ka dɔgɔ {min_items} fɛnw kan, nka u ye {actual_items} fɛnw sɔrɔ",
  "identities.messages.4000025": "fɛnw bɛ kelen ye jateden {index_a} ani {index_b} na",
  "identities.messages.4000026": "u tun b'a fɛ {allowed_types_list}, nka u ye {actual_type} sɔrɔ",
  "identities.messages.4000027": "Jatebɔsɛbɛn bɛ yen kaban ni lasebenw kelen ye (bataki, telefɔni, baarakɛla tɔgɔ, ...). I ka kan ka don i ka jatebɔsɛbɛn kɔrɔla na walasa k'i ka jama ka jatebɔsɛbɛn jɛɲɔgɔnya.",
  "identities.messages.4000028": "I ye a lajɛ ka don ni {credential_identifier_hint} ye min bɛ kɛ baara la ni jatebɔsɛbɛn wɛrɛ ye kaban. I bɛ se ka don ni {available_credential_types_list} ye. I bɛ se ka don ni jama ka don dibagaw dɔ ye ninnu na: {available_oidc_providers_list}.",
  "identities.messages.4000029": "a ka kan ka kɛ kelen ye ni janya {expected} ye",
  "identities.messages.4000030": "janya ma ɲɛ",
  "identities.messages.4000031": "Daɲɛgafe tɛ se ka kɛ baara la bawo a bɛ ɲɔgɔn cɛ kosɛbɛ ni laseben ye.",
  "identities.messages.4000032": "Daɲɛgafe ka kan ka kɛ sɛbɛnni {min_length} dɔɔnin na, nka a ye {actual_length}.",
  "identities.messages.4000033": "Daɲɛgafe ka kan ka kɛ sɛbɛnni {max_length} caman na, nka a ye {actual_length}.",
  "identities.messages.4000034": "U ye daɲɛgafe sɔrɔ kunnafondilanw tigiw bonya la wa a ka kan ka to ka kɛ baara la.",
  "identities.messages.4000035": "Nin jatebɔsɛbɛn tɛ yen walima don ni kode labɛnni ma kɛ a la.",
  "identities.messages.4000036": "Cogoyaw i ye minnu di olu tɛ bɛn cogoyaw ma minnu tun ye jɛɲɔgɔnya kɛ ni nin boli in ye ka kɔn.",
  "identities.messages.4000037": "Nin jatebɔsɛbɛn tɛ yen walima donkow fɛɛrɛ ma labɛn a la.",
  "identities.messages.4000038": "Kaptja kɔrɔbɔli ma ɲɛ, i ka segin k'a lajɛ.",
  "identities.messages.4010001": "N’a fɔ ko, a ka laadala don. Ka taa, ka bɔ a fɔ.",
  "identities.messages.4010002": "Fɛɛrɛ ma sɔrɔ walasa ka don i la. I ye formu in fa ka ɲɛ wa?",
  "identities.messages.4010003": "Fɛɛrɛ ma sɔrɔ walasa k'i tɔgɔ sɛbɛn. I ye formu in fa ka ɲɛ wa?",
  "identities.messages.4010004": "Fɛɛrɛ ma sɔrɔ walasa k'i ka labɛnw yɛlɛma. I ye formu in fa ka ɲɛ wa?",
  "identities.messages.4010005": "Fɛɛrɛ ma sɔrɔ walasa k'i ka jatebɔsɛbɛn segin. I ye formu in fa ka ɲɛ wa?",
  "identities.messages.4010006": "Fɛɛrɛ ma sɔrɔ walasa k'i ka jatebɔsɛbɛn kɔrɔbɔ. I ye formu in fa ka ɲɛ wa?",
  "identities.messages.4010007": "Ɲinini in labɛnna ka ɲɛ kaban wa a tɛ se ka segin kɛ.",
  "identities.messages.4010008": "Donni kode tɛ tiɲɛ walima u ye a kɛ baara la kaban. I ka segin k'a lajɛ.",
  "identities.messages.4010009": "Jaminanw minnu jɛɲɔgɔnyara olu tɛ bɛn ɲɔgɔn ma.",
  "identities.messages.4010010": "Adirɛsi i ye min bila a tɛ bɛn adirɛsiw dɔ ma minnu bɛ nin jatebɔsɛbɛn in kɔnɔ sisan.",
  "identities.messages.4040001": "N’a fɔ ko, a ka laadala don. Ka taa, ka bɔ a fɔ.",
  "identities.messages.4040002": "Ɲinini in labɛnna ka ɲɛ kaban wa a tɛ se ka segin kɛ.",
  "identities.messages.4040003": "Tɔgɔsɛbɛnni kode tɛ tiɲɛ walima u ye a kɛ baara la kaban. I ka segin k'a lajɛ.",
  "identities.messages.4050001": "N’a fɔ ko, a ka laadala don. Ka taa, ka bɔ a fɔ.",
  "identities.messages.4060001": "Ɲinini in labɛnna ka ɲɛ kaban wa a tɛ se ka segin kɛ.",
  "identities.messages.4060002": "Seginni boli sera fili cogoya dɔ la wa a ka kan ka segin kɛ.",
  "identities.messages.4060004": "Seginni taamashɛn tɛ tiɲɛ walima u ye a kɛ baara la kaban. I ka boli in segin kɛ.",
  "identities.messages.4060005": "N’a fɔ ko, a ka laadala don. Ka taa, ka bɔ a fɔ.",
  "identities.messages.4060006": "Seginni kode tɛ tiɲɛ walima u ye a kɛ baara la kaban. I ka segin k'a lajɛ.",
  "identities.messages.4070001": "Kɔrɔbɔli taamashɛn tɛ tiɲɛ walima u ye a kɛ baara la kaban. I ka boli in segin kɛ.",
  "identities.messages.4070002": "Ɲinini in labɛnna ka ɲɛ kaban wa a tɛ se ka segin kɛ.",
  "identities.messages.4070003": "Kɔrɔbɔli boli sera fili cogoya dɔ la wa a ka kan ka segin kɛ.",
  "identities.messages.4070005": "N’a fɔ ko, a ka laadala don. Ka taa, ka bɔ a fɔ.",
  "identities.messages.4070006": "Kɔrɔbɔli kode tɛ tiɲɛ walima u ye a kɛ baara la kaban. I ka segin k'a lajɛ.",
  "identities.messages.5000001": "{reason}",
  "login.logout-button": "Bɔ",
  "login.registration-button": "I tɔgɔ sɛbɛn",
  "login.registration-label": "Jatebɔsɛbɛn t'i bolo wa?",
  "login.title": "Don",
  "login.subtitle": "Don ni {parts} ye",
  "login.title-aal2": "Dantigɛli fila fana",
  "login.subtitle-aal2": "Fɛɛrɛ dɔ sugandi walasa k'i ka dantigɛli fila fana labɛn",
  "login.code.subtitle": "Kɔrɔbɔli kode bɛna ci ni bataki ye",
  "login.webauthn.subtitle": "I ka WebAuthn minɛn labɛn",
  "login.totp.subtitle": "I ka kode min labɛnna ni i ka Dantigɛcogo Porogaramu ye a bila",
  "login.lookup_secret.subtitle": "I ka kope seginni kode 8-jateden dɔ bila i ka kodew kɔnɔ",
  "login.title-refresh": "Segin ka dantigɛ",
  "login.subtitle-refresh": "I yɛrɛ lajɛ ni {parts} ye",
  "login.2fa.go-back": "Fɛn dɔ tɛ baara kɛ wa?",
  "login.2fa.go-back.link": "Segin",
  "login.2fa.method.go-back": "Fɛɛrɛ wɛrɛ sugandi",
  "recovery.title": "I ka jatebɔsɛbɛn segin",
  "recovery.subtitle": "Laseben bila min bɛ jɛɲɔgɔnya kɛ ni i ka jatebɔsɛbɛn ye walasa ka don siɲɛ kelen sɔrɔ",
  "registration.login-button": "Don",
  "registration.login-label": "Jatebɔsɛbɛn bɛ i bolo kaban wa?",
  "registration.title": "Jatebɔsɛbɛn sɛbɛn",
  "registration.subtitle": "I tɔgɔ sɛbɛn ni {parts} ye",
  "settings.navigation-back-button": "Segin",
  "settings.subtitle": "I ka jatebɔsɛbɛn labɛnw yɛlɛma",
  "settings.title": "Jatebɔsɛbɛn Labɛnw",
  "settings.password.title": "Daɲɛgafe Yɛlɛma",
  "settings.password.description": "I ka daɲɛgafe yɛlɛma",
  "settings.profile.title": "Profilu Labɛnw",
  "settings.profile.description": "I ka profilu kunnafoniw yɛlɛma",
  "settings.webauthn.title": "Materyɛli Taamashɛnw Ɲɛnabɔ",
  "settings.webauthn.description": "I ka materyɛli taamashɛnw labɛnw ɲɛnabɔ",
  "settings.messages.toast-title.success": "Labɛnw yɛlɛmana",
  "settings.messages.toast-title.error": "Labɛnw ma se ka yɛlɛma",
  "verification.title": "I ka jatebɔsɛbɛn kɔrɔbɔ",
  "verification.subtitle": "Bataki adirɛsi bila min bɛ jɛɲɔgɔnya kɛ ni i ka jatebɔsɛbɛn ye walasa k'a kɔrɔbɔ",
  "two-step.password.title": "Daɲɛgafe",
  "two-step.password.description": "I ka daɲɛgafe bila min bɛ jɛɲɔgɔnya kɛ ni i ka jatebɔsɛbɛn ye",
  "two-step.code.title": "Bataki kode",
  "two-step.code.description": "Kɔrɔbɔli kode bɛna ci i ka bataki la",
  "two-step.webauthn.title": "Lakana kilisi",
  "two-step.webauthn.description": "I ka lakana kilisi baara walasa ka dantigɛ",
  "two-step.passkey.title": "Daɲɛgafe kilisi (a ɲumanna)",
  "two-step.passkey.description": "I ka minɛn ka bololamayɔrɔ walima ɲɛda dɔnni baara",
  "two-step.passkey.description.error": "Bibliotɛkiw minnu ka kan walasa k'i ka Daɲɛgafe kilisi baara olu ma se ka dɔn. I ka segin k'a lajɛ kɔfɛ.",
  "two-step.totp.title": "I ka Dantigɛcogo Porogaramu (TOTP) baara",
  "two-step.totp.description": "Kode 6-jateden siɲɛ kelen baara i ka dantigɛcogo porogaramu la bɔlen",
  "two-step.lookup_secret.title": "Kope seginni kode",
  "two-step.lookup_secret.description": "I ka kope kode 8-jateden dɔ baara walasa ka dantigɛ",
  "input.placeholder": "I ka {placeholder} bila",
  "card.header.parts.oidc": "jama ka dibaga dɔ",
  "card.header.parts.password.registration": "i ka {identifierLabel} ani daɲɛgafe dɔ",
  "card.header.parts.password.login": "i ka {identifierLabel} ani daɲɛgafe",
  "card.header.parts.code": "siɲɛ kelen kode dɔ",
  "card.header.parts.passkey": "Daɲɛgafe Kilisi dɔ",
  "card.header.parts.webauthn": "lakana kilisi dɔ",
  "card.header.parts.totp": "i ka dantigɛcogo porogaramu",
  "card.header.parts.lookup_secret": "kope seginni kode dɔ",
  "card.header.parts.identifier-first": "i ka {identifierLabel}",
  "misc.or": "walima",
  "forms.label.forgot-password": "I Ye Daɲɛgafe Ɲagami wa?",
  "forms.label.recover-account": "Jatebɔsɛbɛn Segin",
  "settings.totp.title": "Dantigɛcogo Porogaramu",
  "settings.totp.description": "TOTP Dantigɛcogo Porogaramu dɔ fara i ka jatebɔsɛbɛn kan walasa k'i ka jatebɔsɛbɛn lakanacogo ɲɛ. Dantigɛcogo porogaramuw minnu ka di jamaw ma olu ye LastPass ani Google Authenticator ye",
  "settings.totp.info.not-linked": "Walasa k'a bila baara la, i ka QR kode kalan ni i ka dantigɛcogo ye ka kode in bila.",
  "settings.totp.info.linked": "Dantigɛcogo porogaramu dɔ bɛ i bolo sisan min jɛɲɔgɔnyara.",
  "settings.lookup_secret.title": "Kope Seginni Kodew (fɛɛrɛ fila fana)",
  "settings.lookup_secret.description": "Seginni kodew ye lakana kope ye 2FA kama, minnu b'a to i bɛ se ka don i ka jatebɔsɛbɛn na tugun ni i ye i ka 2FA minɛn tiɲɛ.",
  "settings.oidc.title": "Jatebɔsɛbɛnw minnu jɛɲɔgɔnyara",
  "settings.oidc.description": "Jama ka don dibaga dɔ jɛɲɔgɔnya ni i ka jatebɔsɛbɛn ye.",
  "settings.oidc.info": "Jatebɔsɛbɛnw minnu jɛɲɔgɔnyara ni nin dibagaw ye olu bɛ se ka kɛ baara la walasa ka don i ka jatebɔsɛbɛn na",
  "settings.webauthn.info": "Materyɛli Taamashɛnw bɛ kɛ baara la fɛɛrɛ-fila-fana dantigɛli la walima i n'a fɔ fɛɛrɛ fɔlɔ ni Daɲɛgafe Kilisiw ye",
  "settings.passkey.title": "Daɲɛgafe Kilisiw Ɲɛnabɔ",
  "settings.passkey.description": "I ka daɲɛgafe kilisi labɛnw ɲɛnabɔ",
  "settings.passkey.info": "I ka daɲɛgafe kilisi labɛnw ɲɛnabɔ",
  "card.footer.select-another-method": "Fɛɛrɛ wɛrɛ sugandi",
  "account-linking.title": "Jatebɔsɛbɛn jɛɲɔgɔnya",
  "property.password": "daɲɛgafe",
  "property.email": "bataki",
  "property.phone": "telefɔni",
  "property.username": "baarakɛla tɔgɔ",
  "property.identifier": "laseben",
  "property.code": "kode",
  "property.recovery_address": "seginni adirɛsi",
  "consent.title": "Fanga Di {party} Ma",
  "consent.subtitle": "Mɔgɔ sabanan porogaramu dɔ b'a fɛ ka kunnafoniw sɔrɔ minnu bɛ jɛɲɔgɔnya kɛ ni i ka jatebɔsɛbɛn {identifier} ye.",
  "consent.scope.openid.title": "Lasebenw",
  "consent.scope.openid.description": "A b'a to porogaramu bɛ se k'i yɛrɛ dantigɛ. Nin ka kan dantigɛli kama ani don lamɛnni min bɛ se ka da a la.",
  "consent.scope.offline_access.title": "Offline Don",
  "consent.scope.offline_access.description": "A b'a to nin porogaramu in bɛ se k'i to don na hali n'i t'a baara kɛ kosɛbɛ.",
  "consent.scope.profile.title": "Profilu Kunnafoniw",
  "consent.scope.profile.description": "A b'a to i ka profilu kunnafoni jɔnjɔnw sɔrɔ, i n'a fɔ baarakɛla tɔgɔ, tɔgɔ fɔlɔ ani tɔgɔ laban.",
  "consent.scope.email.title": "Bataki Adirɛsi",
  "consent.scope.email.description": "I ka bataki adirɛsi ani a ka kɔrɔbɔli cogoya sɔrɔ.",
  "consent.scope.address.title": "Sigiyɔrɔ Adirɛsi",
  "consent.scope.address.description": "I ka batakisɛbɛn adirɛsi sɔrɔ.",
  "consent.scope.phone.title": "Telefɔni Nimɔrɔ",
  "consent.scope.phone.description": "I ka telefɔni nimɔrɔ ani a ka kɔrɔbɔli cogoya sɔrɔ.",
  "error.title.what-happened": "Mun ye kɛ?",
  "error.title.what-can-i-do": "Ne bɛ se ka mun kɛ?",
  "error.instructions": "I ka segin k'a lajɛ miniti damadɔ kɔnɔ walima ka websaeti baarakɛla kunnafoni.",
  "error.footer.text": "Ni i bɛ nin fili in raportw kɛ, i ka nin kunnafoniw fara a kan:",
  "error.footer.copy": "Kopi kɛ",
  "error.action.go-back": "Segin",
  "identities.messages.4000039": "Sɛgɛsɛgɛlan kura ka kan ka yɛlɛma ni sɛgɛsɛgɛlan kɔrɔ ye.",
  "identities.messages.4000040": "E-mail adrɛsi dafalen don",
  "identities.messages.4000041": "Telefɔni nimɔrɔ dafalen don",
  "captcha.error": "Kɔlɔsili kɛra kɔnɔ, a ma ɲɛ. Hakɛto, a ɲini tugun kɔfɛ. Ni gɛlɛya tora yen, a ɲini dɛmɛ.",
  "identities.messages.5000002": "O yala, o minɛ walima o lajɛla la, a ye. Ka bon ka sistemu lajɛli la.",
  "identities.messages.4010011": "Konti nin bɛ se ka dɔn. Ka kɛ, ka kan ka bonya fɛ.",
  "identities.messages.1070018": "Imɛrɛli tabi nimɛri.",
  "identities.messages.1080004": "An ka taa, an ka kɛlɛ ka kɔrɔtɔrɔ kan, an ka bɔ an ka farikanin bila kan. I n’a fa an ka kɔrɔtɔrɔ la, an ka farikanin bila kan ka jija, o ka bon ka an ka farikanin bila kan ka kɛ ka an ka kɛlɛ an ka farikanin bila kan.",
  "identities.messages.1080005": "I n’a fɔ i ni i ye telefoninuman la, o ka kan ka bon.",
  "identities.messages.5000003": "Nɔrɔgɔn dɔ la, a ka kan ka SSO ni fɛn, nka a ka SSO ni fɛn ye min bɛ. Ka kɔ, ka system administrator la.",
  "identities.messages.1010024": "Fara dɔ la, kɔrɔ la.",
  "identities.messages.1010025": "Kódè cì i ka adɛrɛsi ma. Ni i ma a sɔrɔ, i bɛ a ɲini tugun.",
  "identities.messages.4000042": "I n’a ka faamako DeviceAuthn kan ka kɛ.",
  "identities.messages.4000043": "Wɛbɛ authn kɔnɔgilin la, a ka kan ka ta, ka kɛ ka fɔ.",
  "identities.messages.4000044": "An ka labɛn ko DeviceAuthn kan siginatura fana.",
  "identities.messages.4050002": "I n’a fɔ i n’ bɛ se ka ka dɔrɔn dɔ ka bonya, i n’a fɔ, i n’a fɔ, i n’a fɔ. Ka kɔ, ka dɔrɔn walima ka kɛnɛya in dɔrɔn kan ka bonya."
}
